import { GetBannersQueryType } from 'entities/banner/types';

export const getBannersUrlConfig = ({ appTypes, page, size }: GetBannersQueryType) => {
  const sizeParams = size ? `&size=${size}` : '';
  const pageParams = page ? `&page=${page}` : '';
  const appTypesParams = appTypes ? `&app_types=${appTypes.join('&app_types=')}` : '';

  return `/news-pages/admin/banners?sorting=id${sizeParams}${pageParams}${appTypesParams}`;
};
